import styled from '@emotion/styled';

import { Typography } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Container = styled.div({
  borderRadius: '50%',
});

export const Circle = styled.div<Theme>(({ theme }) => ({
  alignItems: 'center',
  aspectRatio: '1 / 1',
  backgroundColor: theme.colors.paletteFromBO.secondary,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(1),
  position: 'relative',
  width: 'fit-content',
  minWidth: 110,
  '&.small': {
    minWidth: 90,
  },
}));

export const Rank = styled(Typography)<Theme>(({ theme }) => ({
  color: theme.colors.white,
  fontSize: theme.typography.h1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  '&.small': {
    fontSize: theme.typography.h2.fontSize,
  },
}));

export const TotalUsers = styled(Typography)<Theme>(({ theme }) => ({
  bottom: -10,
  color: theme.colors.grey.main,
  fontSize: theme.typography.h2.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  position: 'absolute',
  right: -75,
  '&.small': {
    fontSize: theme.typography.h3.fontSize,
  },
}));
